module.exports = __webpack_public_path__ + "img/mewconnect.46a7e102.jpeg";